<div *ngIf="isPageReady" class="flex flex-col gap-3 p-1">

  <div *ngIf="!rrd" class="text-red-600">RRD #{{ params.rrdId }} not found.</div>
  <div *ngIf="loadError" class="text-red-600">{{ loadError }}</div>

  <div *ngIf="rrd && impact">
    <div class="qb-detail-card qb-primary-tint p-3 mb-3">
      <table class="qb-info-table">
        <tr><td class="label">RRD</td>          <td class="value">#{{ rrd.id }}</td></tr>
        <tr><td class="label">Job Order</td>    <td class="value">{{ rrd.returnRequest?.joHeader?.id }}</td></tr>
        <tr><td class="label">Account</td>      <td class="value">{{ rrd.returnRequest?.joHeader?.account?.accountName }}</td></tr>
        <tr><td class="label">Manufacturer</td> <td class="value">{{ product?.productType?.manufacturer?.name }}</td></tr>
        <tr><td class="label">Style</td>        <td class="value">{{ product?.productType?.style }}</td></tr>
        <tr><td class="label">Features</td>     <td class="value">{{ variantText }}</td></tr>
        <tr><td class="label">Qty</td>          <td class="value">{{ rrd.qty }}</td></tr>
        <tr><td class="label">Current phase</td><td class="value">{{ impact.currentPhase }}</td></tr>
      </table>
    </div>

    <!-- Blocker panel -->
    <div *ngIf="!impact.canRecover" class="qb-detail-card p-3 mb-3">
      <div class="font-semibold mb-2 text-red-600">Recovery is not available</div>
      <div class="text-sm mb-2">
        One or more conditions prevent this RRD from being recovered. Resolve the items below, then try again.
      </div>
      <ul class="list-disc pl-5 text-sm">
        <li *ngFor="let b of impact.blockers">{{ b }}</li>
      </ul>
    </div>

    <!-- Impact preview -->
    <div *ngIf="impact.canRecover" class="qb-detail-card p-3 mb-3">
      <div class="font-semibold mb-2">What will be deleted</div>
      <div *ngIf="!hasArtifacts" class="text-sm text-muted italic">
        This RRD has not produced any artifacts yet. Recovery will only reset its phase to RECEIVING.
      </div>
      <ul *ngIf="hasArtifacts" class="list-disc pl-5 text-sm">
        <li *ngIf="impact.itemDetailIds.length > 0">
          <strong>{{ impact.itemDetailIds.length }}</strong> ItemDetail<span *ngIf="impact.itemDetailIds.length !== 1">s</span>
          ({{ impact.itemDetailIds.join(", ") }})
        </li>
        <li *ngIf="impact.itemDetailAddonIds.length > 0">
          <strong>{{ impact.itemDetailAddonIds.length }}</strong> ItemDetailAddon<span *ngIf="impact.itemDetailAddonIds.length !== 1">s</span>
          attached to those ItemDetails
        </li>
        <li *ngIf="impact.creditMemoIds.length > 0">
          <strong>{{ impact.creditMemoIds.length }}</strong> CreditMemo<span *ngIf="impact.creditMemoIds.length !== 1">s</span>
          (id<span *ngIf="impact.creditMemoIds.length !== 1">s</span> {{ impact.creditMemoIds.join(", ") }})
        </li>
      </ul>
      <div class="text-xs text-muted mt-2 italic">
        After deletion, the RRD will return to RECEIVING with all phase decisions cleared. The Routing,
        Settlement, and any reconciliation notes will remain in the audit feed.
      </div>
    </div>

    <!-- Reason -->
    <div *ngIf="impact.canRecover" class="qb-detail-card p-3 mb-3">
      <div class="font-semibold mb-2">Reason for Recovery</div>
      <div class="text-sm text-muted mb-2">
        Briefly describe why this RRD needs to be reset. The reason is included in the audit JoNote.
      </div>
      <div class="grid grid-cols-12 gap-3 items-start">
        <label class="col-span-3 font-semibold pt-2">Reason</label>
        <textarea pTextarea
                  rows="3"
                  class="col-span-9 w-full"
                  title="Reason for recovery"
                  [(ngModel)]="reason"
                  [disabled]="submitting"
                  placeholder="e.g. Wrong product routed; operator picked the wrong size."></textarea>
      </div>
    </div>

    <div *ngIf="errorMessage" class="text-red-600 mb-2">{{ errorMessage }}</div>
  </div>

  <div class="flex justify-end gap-2 pt-3 border-t">
    <button pButton type="button"
            class="p-button-text"
            [disabled]="submitting"
            (click)="cancel()">
      <span>Cancel</span>
    </button>
    <button pButton type="button"
            class="p-button-raised"
            icon="pi pi-undo"
            [disabled]="!canSubmit"
            (click)="confirm()">
      <span>Recover to RECEIVING</span>
    </button>
  </div>
</div>
